<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">
        <section id="header">
            <h1 class="h1Header">ADMINISTRAR CIUDADES</h1>
        </section>
        <section id="table">
            <mat-card class="mat-elevation-z0">
                <div>
                    <button mat-flat-button class="add-btn" (click)="addCity()">Agregar nueva</button>
                </div>
                <table mat-table [dataSource]="allCities" class="mat-elevation-z0">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="table-header">NOMBRE</th>
                        <td mat-cell *matCellDef="let city"> {{city.dsName | uppercase}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
                        <td mat-cell *matCellDef="let city">
                            <p [style.color]="city.isActive ? 'blue' : '#F44336'">{{city.isActive | status}}</p>
                            <button mat-flat-button (click)="changeCityStatus(city.cdCity, city.isActive, city.dsName)"
                                [ngClass]="{'activate-btn': !city.isActive, 'deactivate-btn': city.isActive}">
                                {{city.isActive | changeStatus}}</button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="option">
                        <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
                        <td mat-cell *matCellDef="let city">
                            <button mat-mini-fab class="edit-btn" 
                            matTooltip="Editar ciudad" (click)="editCity(city.cdCity)">
                                <mat-icon>create</mat-icon>
                            </button>
                            <button mat-mini-fab class="delete-btn"
                            matTooltip="Eliminar ciudad" (click)="deleteCity(city.cdCity)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>
